import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import { Link } from 'src/components/widgets/buttons';

// New AI credits/billing policy shown in the "EXTRA" banner on every AI tool page. Single text for all
// platforms; full policy lives in the AI Credits and Billing help article.
export const AI_CREDITS_BILLING_URL = 'https://zakeke.zendesk.com/hc/en-us/articles/31154048227740-AI-Credits-and-Billing';

export const AiCreditsBannerContent: FC = () => (
    <>
        {T._(
            "Each output generated by your customers uses AI credits. Zakeke provides an initial free credit pack covering all AI features. Once used up, additional usage is automatically billed at the end of your account's billing period. ",
            'Admin'
        )}
        <Link href={AI_CREDITS_BILLING_URL} target={'_blank'}>
            {T._('Learn more', 'Admin')}
        </Link>
        {'.'}
    </>
);

export default AiCreditsBannerContent;
